import PageContainer from "../../../../../components/PageContainer/PageContainer";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { restUseCase } from "../../../../../usecases/rest";
import FormUtils from "../../../../../utils/classUtils/FormUtils";
import withRouter from "../../../../../utils/withRouter";
import ProfileFormPresenter from "../../user-profile/profile-form-page/ProfileFormPresenter";
import Card from "./components/Card";
import { affiliateAndBranchData } from "./data/affiliateAndBranchData";
import { personalInformationData } from "./data/personalInformation";

class PendingUserDetailsPage extends FormUtils {
  constructor(props) {
    super(props);
    this.state = { object: {}, modalState: false };
    this.presenter = new ProfileFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      restUseCase()
    );
  }

  getCollectionName() {
    return "users";
  }

  render() {
    const { object } = this.state;

    return (
      <PageContainer
        title="Pending User Details"
        navigateBack={this.navigateBack.bind(this)}
      >
        <div className="mt-3 d-flex gap-4 flex-column">
          <Card
            header="Personal Information"
            data={personalInformationData(object)}
          />
          <Card
            header="Affiliate and Branch"
            data={affiliateAndBranchData(object)}
          />
        </div>
      </PageContainer>
    );
  }
}

export default withRouter(PendingUserDetailsPage);
